<template>
  <div class="d-flex gap-3">
    <CountCard
      data-testid="user-permission__total-users-card"
      :count="userDataSummary.total_users || 0"
      page-name="users available"
      label-key="total_users_label"
      fallback-label="Users Available"
      :border-color="'#2C2C35'"
      :background-color="'#F7F7F7'"
      :height="'44px'"
      showWhenZero
    ></CountCard>
    <CountCard
      data-testid="user-permission__active-users-card"
      :count="userDataSummary.active_users || 0"
      page-name="users active"
      label-key="active_users_label"
      fallback-label="Users Active"
      :border-color="'#38B000'"
      :background-color="'#F3F8F5'"
      color="#298159"
      :height="'44px'"
      showWhenZero
    ></CountCard>
    <CountCard
      data-testid="user-permission__inactive-users-card"
      :count="userDataSummary.inactive_users || 0"
      page-name="users inactive"
      label-key="inactive_users_label"
      fallback-label="Users Inactive"
      :border-color="'#FF4D4D'"
      :background-color="'#FDF4F4'"
      :height="'44px'"
      showWhenZero
    ></CountCard>
  </div>
</template>

<script>
import CountCard from '@/components/CommonCountCard.vue';

export default {
  name: 'UserPermissionUserCount',
  components: {
    CountCard,
  },
  props: {
    userDataSummary: {
      type: Object,
      required: true,
      default: () => ({
        total_users: 0,
        active_users: 0,
        inactive_users: 0,
      }),
    },
  },
};
</script>
